(() => {
  document.querySelectorAll('[data-pink-script-product]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-product-form]');
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-price]');
    const stock = root.querySelector('[data-stock]');
    const add = root.querySelector('[data-add-to-cart]');
    const checkout = root.querySelector('[data-dynamic-checkout]');
    const feedback = root.querySelector('[data-form-feedback]');
    if (!form || !select || !price || !stock || !add || !feedback) return;
    const currency = window.Shopify?.currency?.active || 'USD';
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(Number(cents) / 100);
    const sync = () => {
      const option = select.selectedOptions[0];
      const chosen = Boolean(select.value && option);
      const available = chosen && option.dataset.available === 'true';
      if (chosen && option.dataset.price) price.textContent = money(option.dataset.price);
      add.disabled = !available;
      if (checkout) checkout.hidden = !available;
      stock.textContent = chosen ? (available ? 'Available to order' : 'Currently unavailable') : 'Select a size to continue';
    };
    select.addEventListener('change', () => { feedback.textContent = ''; sync(); });
    root.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => {
      root.querySelectorAll('[data-media-id]').forEach((media) => { media.hidden = media.dataset.mediaId !== button.dataset.mediaTarget; });
      root.querySelectorAll('[data-media-target]').forEach((item) => item.removeAttribute('aria-current'));
      button.setAttribute('aria-current', 'true');
    }));
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!select.value) { feedback.textContent = 'Please select a size.'; select.focus(); return; }
      feedback.textContent = 'Adding to cart…'; add.disabled = true;
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(select.value), quantity: 1 }] }) });
        if (!response.ok) throw new Error('Cart rejected the selected variant');
        await response.json();
        feedback.textContent = 'Taking you to checkout…';
        window.location.assign('/checkout');
      } catch (_error) { feedback.textContent = 'We could not add this item. Please try again.'; }
      finally { sync(); }
    });
    sync();
  });
})();
